@use '../../design-tokens/typography/typography' as *;
@use '../../design-tokens/border-radius/border-radius' as *;

@layer design-system {
  .wrapper {
    display: flex;
    flex-direction: column;
  }

  .checkboxElement {
    position: absolute;
    appearance: none;
  }

  .checkIcon {
    fill: var(--text-on-primary);
    display: none;
  }

  .checkmark {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    height: 18px;
    width: 18px;
    margin-right: 8px;
    margin-top: 3px;
    border: 1px solid var(--border-default);
    @include border-radius-r1;

    .checkboxElement:focus-visible + & {
      outline-offset: 2px;
      outline: var(--border-focus) solid 2px;
    }
  }

  .checkboxLabel {
    color: var(--text-default);
  }

  .checkboxLabelWithTooltip {
    border-bottom: 1px dashed var(--border-default);
  }

  .checkbox {
    display: inline-flex;
    cursor: pointer;

    &.disabled {
      cursor: default;
    }

    // CheckboxLabel typography by size
    &.sizeMedium .checkboxLabel {
      @include typography-v2-body-base;
    }

    &.sizeSmall .checkboxLabel {
      @include typography-v2-body-sm;
    }

    // Locked or disabled label color
    &.locked .checkboxLabel,
    &.disabled .checkboxLabel {
      color: var(--surface-neutral);
    }

    // CheckIcon visibility when checked
    &.checked .checkIcon {
      display: inline-flex;
    }

    // Primary variant
    &.primary .checkmark {
      border-color: var(--border-default);
    }

    &.primary:hover .checkmark {
      border-color: var(--border-hover);
    }

    &.primary.checked .checkmark {
      border-color: var(--border-primary);
      background-color: var(--surface-primary);
    }

    &.primary.checked:hover .checkmark {
      border-color: var(--border-primary);
    }

    // Critical variant
    &.critical .checkmark {
      border-color: var(--border-critical);
    }

    &.critical.checked .checkmark {
      border-color: var(--border-critical);
      background-color: var(--surface-critical);
    }

    // Disabled variant
    &.disabled .checkmark {
      border-color: var(--border-disabled);
    }

    &.disabled.checked .checkmark {
      border-color: var(--surface-neutral);
      background-color: var(--surface-neutral);
    }
  }

  .lockIcon {
    margin-right: 12px;
    fill: var(--surface-neutral);
  }

  .errorText {
    display: block;
    text-align: left;
    color: var(--text-critical);
    @include typography-v2-body-sm;
  }
}
